import { Component, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { DashboardFilterModel } from "../dashboard-filter-model";
import { IDashBoardAdminChartDetailsWithProvider, ICampaignChart } from "../dasboard-admin-chart-details.model";
import { UniqueModel } from "../uniques/unique.model";
import { RevenueComponent } from "../revenue/revenue.component";
import { ViewsComponent } from "../views/views.component";
import { DashBoardAdminService } from "../dashboard-admin.service";
import { LastUpdateBroadcaster } from "../../core/broadcasts/last-updated-broadcaster";
import { DateHelperService } from "../../core/services/index";
import { Observable } from "rxjs/Observable";
import { DashboardAdminStyleService } from "../dashboard-admin-style.service";

@Component({
    moduleId: module.id,
    templateUrl: 'publisher-dashboard.component.html'
})

export class PublisherDashboardComponent implements OnDestroy, AfterViewInit {
    errorMessage: any;
    detailsByProvider: IDashBoardAdminChartDetailsWithProvider;
    detailsByProviderForToday: IDashBoardAdminChartDetailsWithProvider;
    detailsByProviderPeriod: string;
    campaignDetails: ICampaignChart;
    showProviderBottom: boolean = false;
    uniqueRequestsCount: number = 0;
    showTopSectionOverlay: boolean = true;
    showCampaignOverlay: boolean = true;
    private readonly IntervalBetWeenAutoRefresh: number = 5000;
    private topSectionSubscribeAutoRefresh: any;
    private topSectionFilters: DashboardFilterModel;
    readonly firstPanelId: string = "firstPanelId";
    private inXhrProviderForToday: any;
    private inXhrProvider: any;
    private inXhrUniqueRequests: any;
    eCpmValue: number = 0;
    uniqueModel: UniqueModel;
    private inXhrGetVersionNumber: any;
    versionNumber: string;

    @ViewChild("revenueByAppChild") revenueComponent: RevenueComponent
    @ViewChild("viewsChild") viewsComponent: ViewsComponent

    constructor(
        private dashBoardAdminService: DashBoardAdminService,
        private lastUpdateBroadcaster: LastUpdateBroadcaster,
        private dateHelper: DateHelperService,
        private dashboardAdminStyleService: DashboardAdminStyleService) {
    }

    ngOnInit() {
        this.inXhrGetVersionNumber = this.dashBoardAdminService.getVersionNumber()
            .subscribe((res: any) => {
                this.versionNumber = res.json();
            }, null, null);
    }

    onChildLoaded() {
        if (this.viewsComponent.totalCompletedViews > 0 && this.revenueComponent.totalEarnings > 0)
            this.eCpmValue = this.revenueComponent.totalEarnings / this.viewsComponent.totalCompletedViews * 1000;
        else
            this.eCpmValue = 0;
    }

    onResize(event) {
        // calculates height of panels and makes them same height
        this.dashboardAdminStyleService.equalizeTopSectionCards();
        this.dashboardAdminStyleService.equalizeBottomSectionCards();
    }

    ngOnDestroy() {
        this.unsubsribeCurrentCalls();
        this.topSectionUnSubscribeAutoRefresh();
    }

    ngAfterViewInit() {
        let firstPanelId = '#' + this.firstPanelId;
        this.dashboardAdminStyleService.afterViewInit(firstPanelId, '', this);
    }

    public topSectionFilter(filters: DashboardFilterModel) {
        this.showTopSectionOverlay = true;
        this.topSectionFilters = filters;
        this.detailsByProviderPeriod = filters.period;
        this.getDetailsByProvider();
        this.getUniqueRequests();
    }

    private getDetailsByProvider(): void {
        if (this.inXhrProvider) {
            this.inXhrProvider.unsubscribe();
        }
        this.inXhrProvider = this.dashBoardAdminService.getDetailsByProvider(this.topSectionFilters)
            .subscribe(data => { this.detailsByProvider = data, this.lastUpdateBroadcaster.event.next(true) },
                error => { this.errorMessage = <any>error },
                () => { this.onCompleteGetDetailsByProvider() });
    }

    private getUniqueRequests(): void {
        if (this.inXhrUniqueRequests) {
            this.inXhrUniqueRequests.unsubscribe();
        }
        this.inXhrUniqueRequests = this.dashBoardAdminService.getUniqueRequests(this.topSectionFilters.publisherIds)
            .subscribe(data => this.uniqueModel = data, error => this.errorMessage = <any>error, () => { });
    }

    private topSectionUnSubscribeAutoRefresh(): void {
        if (this.topSectionSubscribeAutoRefresh) {
            this.topSectionSubscribeAutoRefresh.unsubscribe();
            this.topSectionSubscribeAutoRefresh = undefined;
        }
    }

    private topSectionSubscribeToAutoRefresh(): void {
        if (this.dateHelper.isToday(this.topSectionFilters.endDate))
            this.topSectionSubscribeAutoRefresh = Observable.interval(this.IntervalBetWeenAutoRefresh)
                .subscribe(() => { this.getDetailsByProviderForToday(); this.getUniqueRequests();});
    }

    private getDetailsByProviderForToday(): void {
        if (this.inXhrProviderForToday) {
            this.inXhrProviderForToday.unsubscribe();
        }
        this.inXhrProviderForToday = this.dashBoardAdminService.getDetailsByProviderForToday(this.topSectionFilters)
            .subscribe(data => {
                this.detailsByProviderForToday = data;
                this.lastUpdateBroadcaster.event.next(true);
            },
                error => { this.errorMessage = <any>error, this.topSectionUnSubscribeAutoRefresh() });
    }

    private onCompleteGetDetailsByProvider(): void {
        this.topSectionSubscribeToAutoRefresh();
        this.showTopSectionOverlay = false;
    }

    private unsubsribeCurrentCalls(): void {
        if (this.inXhrProviderForToday)
            this.inXhrProviderForToday.unsubscribe();
        if (this.inXhrProvider)
            this.inXhrProvider.unsubscribe();
        if (this.inXhrGetVersionNumber)
            this.inXhrGetVersionNumber.unsubscribe();
        if (this.inXhrUniqueRequests)
            this.inXhrUniqueRequests.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/publisher-dashboard/publisher-dashboard.component.ts